import EventList from '../_mockApis/EventList';

const get = (offset = 0, size = 50) => EventList;

const EventController = {
    get
};

export default EventController;
